// extracted by css-extract-rspack-plugin
var _1 = "diff-F7Prws";
var _2 = "drawer-attaYR";
var _3 = "timestamps-pr5Npe";
export { _1 as "diff", _2 as "drawer", _3 as "timestamps" }
